<template>
  <div class="animated fadeIn">
    <div class="cardheading">
      <h4><i class="fa fa-user"></i><span class="ml-1">Bkash Banners</span></h4>
      <div class="">
        <h1 class="my-auto tableName"></h1>
      </div>
      <div class="">
        <router-link to="/bkash-promotions/banner/create">
          <p class="my-0">
                  <span class="btn btn-success new-cat-btn-name p-2">
                      Add New Banner <b> + </b>
                  </span>
          </p>
        </router-link>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <v-server-table :columns="columns" :options="options">
          <template slot="banner" slot-scope="props">
            <div class="center-div">
              <img :src="`${BASE_URL}/${props.row.url}`" style="width: 160px;height: 90px;">
            </div>
          </template>
          <template slot="banner_type" slot-scope="props">
            <div class="center-div">
              <span>{{convertTitle(props.row.banner_type)}}</span>
            </div>
          </template>
          <template slot="is_published" slot-scope="props">
            <div class="center-div">
              <CBadge :color="`${props.row.is_published ? 'success':'dark'}`" shape="rounded-pill">{{props.row.is_published ? 'published':'not published'}}</CBadge>
            </div>
          </template>
          <template slot="platform" slot-scope="props">
            <div class="center-div">
              <CBadge>{{(props.row.nagorik_game_slug!=="null") ? props.row.nagorik_game.game_name:'Bkash Landing'}}</CBadge>
            </div>
          </template>
          <template slot="action" slot-scope="props">
            <div>
              <router-link :to="`/bkash-promotions/banner/edit/${props.row.id}`">
                <span class="btn btn-warning btn-sm m-1" data-toggle="tooltip"  data-placement="top" title="Edit"> <CIcon name="cil-pencil" size="sm" /></span>
              </router-link>
              <router-link to="" >
                <span @click="handleDelete(props.row)" class="btn btn-danger btn-sm m-1" data-toggle="tooltip"  data-placement="top" title="Delete"> <CIcon name="cil-basket" size="sm" /></span>
              </router-link>
            </div>
          </template>
        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const BASE_URL = process.env.VUE_APP_ROOT_URL;

export default {
  name: 'Users',
  data() {
    var url = `${ADMIN_URL}/bkash-banners`;
    return {
      BASE_URL: BASE_URL,
      users: [],
      columns: ['banner','banner_type','weight','is_published','redirect_url','platform','created_at','action'],
      options: {
        requestFunction(data) {
          data.limit = 30;
          return axios.get(url, {
            params: data
          })
        },

        responseAdapter({data}) {
          return data;
        },

        pagination: {nav: 'fixed'},
        filterByColumn: true,
        toMomentFormat: 'YYYY-MM-DD',
        sortIcon: {base: 'fa fa-sort', up: 'fa fa-sort-up', down: 'fa fa-sort-down', is: 'fa fa-sort'},

      }
    }
  },

  methods: {
    convertTitle(s){
      return s.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
          .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase());
    },
    handleDelete(parm) {
      if (confirm('Are you sure?') ) {
        const banner_id = parm.id;
        axios.post(`${ADMIN_URL}/bkash-banner/delete/${banner_id}`)
            .then(response => {
              alert('Banner Deteted Successfully');
              window.location.href = "/bkash-promotions/banners";
            }).catch(error => {

        })

      } else {

      }
    },

  }
}
</script>

<style scoped>

</style>
